import { palette } from '@livable/saas-react-components';
const MuiBreadcrumbs = {
  styleOverrides: {
    separator: {
      margin: '0 4px',
      '& path': {
        fill: palette.shades[600]
      }
    },
    li: {
      color: palette.shades[800],
      '& .MuiLink-root': {
        color: palette.primary.dark,
        '& .MuiTypography-root': {
          color: 'inherit',
          transition: "color ".concat(palette.transitions.short),
          '&:hover': {
            color: palette.shades[800],
            '& .MuiSvgIcon-root path': {
              fill: palette.shades[800]
            }
          }
        }
      }
    }
  }
};
export default MuiBreadcrumbs;